import { useIntl } from 'react-intl';

import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { OnboardingIdType } from '~/features/onboarding/OnboardingIdType';

const Page = () => {
  const intl = useIntl();
  const onboardingIds = [OnboardingIdType.OnboardingGuide];
  return (
    <PageLayout
      title={intl.formatMessage({
        id: 'OnboardingPage.pageTitle',
        defaultMessage: 'Onboarding',
        description: 'Page title for onboarding page',
      })}
      welcome={{ onboardingIds }}
    />
  );
};

export default Page;
